import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-pie-chart',
	templateUrl:'./PieChartPluginCompPage.html',
	styles: [],
	styleUrls:['./PieChartPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class PieChartPluginCompPage
{
	mdContent_1090 = `\`\`\`java
import com.jwebmp.plugins.chartjs.PieChart;
\`\`\``;
	mdContent_1091 = `\`\`\`java
PieChart(PieData data)
\`\`\``;
	mdContent_1092 = `\`\`\`java
PieDataset dataset = new PieDataset()
    .setData(300, 50, 100)
    .addBackgroundColors(Color.RED, Color.BLUE, Color.YELLOW);
PieData data = new PieData()
    .addLabels("Red", "Blue", "Yellow")
    .addDataset(dataset);
\`\`\``;
}
